import { type IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';

export const IconWatch = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={iconStyles({ ...props, className: styles.watch })}
  >
    <path d="M15.58 16.66 12 14.3V8.49M12.95 2.89h1.46V.4H9.6v2.49h1.46v2.19" />
    <path d="M9.6 5.35a9.276 9.276 0 0 0-6.87 8.96c0 5.12 4.15 9.28 9.28 9.28s9.28-4.15 9.28-9.28a9.27 9.27 0 0 0-8.33-9.23V3.69" />
  </svg>
);
